// Based on .env VITE_ENV_MODE
export const PRODUCTION_ENVS = ["staging", "platform"];
export const TEST_STAGING_ENV_MODE = "test";
export const TEST_DEV_ENV_MODE = "test-dev";
export const DEV_ENV_MODE = "development";

export type FlagName =
  | "FEATURE_TOUR"
  | "DASHBOARD_OVERVIEW_CUSTOMER"
  | "PHS_CUSTOMER_SEND_TEST_LURE"
  | "SEG_CHECKBOX"
  | "MSP_BRANDING"
  | "PHS_NOTIFY_MANAGER"
  | "CYBERSENTRIQ_ANNOUNCEMENT_MODAL"
  | "INCIDENTS_V3_CATEGORIES"
  | "REPORT_MANAGER_PHS_USER_REPORT"
  | "MSP_OVERVIEW_CHART"
  | "SAT_SUBTITLES"
  | "SAT_ADVANCED_FILTERS"
  | "BLOCK_LIST"
  | "SAT_QUIZ"
  | "BLOCK_LIST_DELETE"
  | "EMAIL_HISTORY_STATUS_FILTER"
  | "EMAIL_HISTORY_VERDICT_FILTER"
  | "DASHBOARD_EMAIL_ARCHIVING_CARD"
  | "EMAIL_HISTORY_CUSTOMER_FILTER"
  | "EMAIL_HISTORY_DATE_FILTER"
  | "BLOCK_LIST_DOMAIN"
  | "BLOCK_LIST_IP";

type Config = {
  [K in FlagName]: {
    dev: boolean;
    testDev: boolean;
    testStaging: boolean;
    prod: boolean;
  };
};

export const FLAGS_CONFIG: Config = {
  FEATURE_TOUR: {
    dev: false,
    testDev: false,
    testStaging: false,
    prod: false,
  },
  DASHBOARD_OVERVIEW_CUSTOMER: {
    dev: false,
    testDev: false,
    testStaging: false,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-sherman/-/issues/1706
  PHS_CUSTOMER_SEND_TEST_LURE: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/1956
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/1957
  SEG_CHECKBOX: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-platfarmers/-/issues/2593
  MSP_BRANDING: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/1240
  INCIDENTS_V3_CATEGORIES: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-sherman/-/issues/1668
  PHS_NOTIFY_MANAGER: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  CYBERSENTRIQ_ANNOUNCEMENT_MODAL: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-sherman/-/issues/1766
  REPORT_MANAGER_PHS_USER_REPORT: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-platfarmers/-/issues/2656
  MSP_OVERVIEW_CHART: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-sherman/-/issues/2446
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-sherman/-/issues/2524
  SAT_SUBTITLES: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },

  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-sherman/-/issues/2483
  SAT_ADVANCED_FILTERS: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-sherman/-/issues/2440
  SAT_QUIZ: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
  // https://gitlab.titanhq.com/groups/titanhq/dev/scrum/-/epics/223
  BLOCK_LIST: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/2556
  BLOCK_LIST_DELETE: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/2697
  EMAIL_HISTORY_STATUS_FILTER: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/2699
  EMAIL_HISTORY_VERDICT_FILTER: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-platfarmers/-/issues/3572
  DASHBOARD_EMAIL_ARCHIVING_CARD: {
    dev: true,
    testDev: false,
    testStaging: false,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/2696
  EMAIL_HISTORY_CUSTOMER_FILTER: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/2700
  EMAIL_HISTORY_DATE_FILTER: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/2607
  BLOCK_LIST_DOMAIN: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/2601
  BLOCK_LIST_IP: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
};
